import FilterListingItemContent from './FilterListingItemContent';

export default FilterListingItemContent;
